import React, { useEffect, useState } from "react";
import { Modal, Row, Col, notification, Button, Skeleton, Divider } from "antd";
import moment from "moment";
import axios from "axios";

const confirm = Modal.confirm;

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({ message, description });
};

const ModalEstudoCasoPAEE = ({ id, visible, onCancel, onDelete }) => {
    const [dadosAluno, setDadosAluno] = useState(null);
    const [dadosEstudoCaso, setDadosEstudoCaso] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const carregarDetalhe = id => {
        setIsLoading(true);
        axios({ method: "get", url: "/api/estudo-caso/carregar-estudo-caso-paee", params: { id: id } })
            .then(response => {
                const aluno = JSON.parse(response.data.dados_aluno || "{}");
                const estudo = JSON.parse(response.data.dados_estudo_caso || "{}");

                setDadosAluno({
                    ...aluno,
                    data_nascimento: moment(aluno.data_nascimento).format("DD/MM/YYYY"),
                    data_registro: moment(aluno.data_registro).format("DD/MM/YYYY")
                });
                setDadosEstudoCaso(estudo);
            })
            .catch(() => openNotificationWithIcon("error", "Erro", "Erro ao carregar o estudo de caso."))
            .finally(() => setIsLoading(false));
    };

    const validarExcluir = () => {
        confirm({
            title: "Pretende remover este estudo de caso?",
            okText: "Confirmar",
            cancelText: "Cancelar",
            onOk: () => excluir()
        });
    };

    const excluir = () => {
        axios({ method: "put", url: "/api/estudo-caso/excluir-plano-estudo-caso-paee", params: { id } })
            .then(() => {
                openNotificationWithIcon("success", "Removido", "Estudo de caso removido com sucesso.");
                onDelete();
            })
            .catch(() => openNotificationWithIcon("error", "Erro", "Erro ao excluir o estudo de caso."));
    };

    useEffect(() => {
        if (id && visible) carregarDetalhe(id);
    }, [id]);

    const renderField = (label, value, span = 12) => (
        <Col span={span}>
            <span className="field-label">{label}</span>
            <Skeleton loading={isLoading} paragraph={false} active width={30} className="field-skeleton">
                <p className="field-value">{value || "-"}</p>
            </Skeleton>
        </Col>
    );

    const renderFieldWide = (title, value) => (
        <div className="modal-detalhe-info__section">
            <h3 style={{ marginTop: 16 }} className="modal-detalhe-info__section-title">
                {title}
            </h3>

            <Row gutter={16}>
                <Col span={24}>
                    <Skeleton loading={isLoading} title={false} active width={30} className="field-skeleton">
                        <p className="field-value--wide">{value || "-"}</p>
                    </Skeleton>
                </Col>
            </Row>
        </div>
    );

    return (
        <Modal
            title="Estudo de Caso PAEE"
            className="modal-detalhe-info"
            visible={visible}
            onCancel={onCancel}
            footer={[
                <Button key="cancelar" onClick={onCancel}>
                    Fechar
                </Button>,
                <Button key="eliminar" className="modal-detalhe-info-delete-btn" type="danger" onClick={validarExcluir}>
                    Excluir estudo
                </Button>
            ]}
            centered
            width={800}
            bodyStyle={{ maxHeight: "70vh", overflowY: "auto" }}
        >
            <div className="modal-detalhe-info__body">
                {/* 1. Identificação */}
                <div className="modal-detalhe-info__section">
                    <h3 style={{ marginTop: 16 }} className="modal-detalhe-info__section-title">
                        1. Identificação do Estudante
                    </h3>

                    <Row gutter={16}>
                        <Col span={12}>
                            <span className="field-label">Nome</span>
                            <Skeleton loading={isLoading} paragraph={false} active width={30} className="field-skeleton">
                                <p className="field-value">{dadosAluno?.nome}</p>
                            </Skeleton>
                        </Col>
                        <Col span={12}>
                            <span className="field-label">Data de Nascimento</span>
                            <Skeleton loading={isLoading} paragraph={false} active width={30} className="field-skeleton">
                                <p className="field-value">{dadosAluno?.data_nascimento || "-"}</p>
                            </Skeleton>
                        </Col>

                        <Col span={12}>
                            <span className="field-label">Idade</span>
                            <Skeleton loading={isLoading} paragraph={false} active width={30} className="field-skeleton">
                                <p className="field-value">{dadosAluno?.idade || "-"}</p>
                            </Skeleton>
                        </Col>
                        <Col span={12}>
                            <span className="field-label">Escola</span>
                            <Skeleton loading={isLoading} paragraph={false} active width={30} className="field-skeleton">
                                <p className="field-value">{dadosAluno?.escola || "-"}</p>
                            </Skeleton>
                        </Col>

                        <Col span={12}>
                            <span className="field-label">Ano/Turma</span>
                            <Skeleton loading={isLoading} paragraph={false} active width={30} className="field-skeleton">
                                <p className="field-value">{dadosAluno?.ano_turma || "-"}</p>
                            </Skeleton>
                        </Col>
                        <Col span={12}>
                            <span className="field-label">Turno</span>
                            <Skeleton loading={isLoading} paragraph={false} active width={30} className="field-skeleton">
                                <p className="field-value">{dadosAluno?.turno || "-"}</p>
                            </Skeleton>
                        </Col>

                        <Col span={12}>
                            <span className="field-label">Professor(a) Regente</span>
                            <Skeleton loading={isLoading} paragraph={false} active width={30} className="field-skeleton">
                                <p className="field-value">{dadosAluno?.professor_regente || "-"}</p>
                            </Skeleton>
                        </Col>

                        <Col span={12}>
                            <span className="field-label">Professor(a) de AEE</span>
                            <Skeleton loading={isLoading} paragraph={false} active width={30} className="field-skeleton">
                                <p className="field-value">{dadosAluno?.professor_aee || "-"}</p>
                            </Skeleton>
                        </Col>

                        <Col span={12}>
                            <span className="field-label">Data</span>
                            <Skeleton loading={isLoading} paragraph={false} active width={30} className="field-skeleton">
                                <p className="field-value">{dadosAluno?.data_registro || "-"}</p>
                            </Skeleton>
                        </Col>
                    </Row>
                </div>

                {renderFieldWide("2. Motivo do Estudo de Caso", dadosEstudoCaso?.motivo_estudo_caso)}
                {renderFieldWide("3. Histórico Escolar", dadosEstudoCaso?.historico_escolar)}
                {renderFieldWide("4. Histórico do Desenvolvimento", dadosEstudoCaso?.historico_desenvolvimento)}
                {renderFieldWide("5. Informações da Família", dadosEstudoCaso?.informacoes_familia)}
                {renderFieldWide("6. Observação do Estudante no Contexto Escolar", dadosEstudoCaso?.observacao_contexto_escolar)}
                {renderFieldWide("7. Aspectos da Aprendizagem", dadosEstudoCaso?.aspectos_aprendizagem)}
                {renderFieldWide("8. Potencialidades e Interesses", dadosEstudoCaso?.potencialidades_interesses)}
                {renderFieldWide("9. Barreiras Identificadas", dadosEstudoCaso?.barreiras_identificadas)}

                {renderFieldWide("10. Recursos de Acessibilidade e Estratégias", dadosEstudoCaso?.recursos_acessibilidade)}
                {renderFieldWide("11. Necessidades Educacionais Identificadas", dadosEstudoCaso?.necessidades_educacionais)}

                <div className="modal-detalhe-info__section">
                    <h3 style={{ marginTop: 16 }} className="modal-detalhe-info__section-title">
                        12. Definição do AEE
                    </h3>

                    <h4 style={{ marginTop: 16 }} className="modal-detalhe-info__section-title">
                        Objetivos geral do AEE
                    </h4>
                    <Row gutter={16}>
                        <Col span={24}>
                            <Skeleton loading={isLoading} title={false} active width={30} className="field-skeleton">
                                <p className="field-value--wide">{dadosEstudoCaso?.definicao_atendimento_objetivo_geral || "-"}</p>
                            </Skeleton>
                        </Col>
                    </Row>
                    <h4 style={{ marginTop: 16 }} className="modal-detalhe-info__section-title">
                        Objetivos específicos
                    </h4>
                    <Row gutter={16}>
                        <Col span={24}>
                            <Skeleton loading={isLoading} title={false} active width={30} className="field-skeleton">
                                <p className="field-value--wide">{dadosEstudoCaso?.definicao_atendimento_objetivos_especificos || "-"}</p>
                            </Skeleton>
                        </Col>
                    </Row>
                </div>

                {renderFieldWide("13. Plano de Intervenção do AEE", dadosEstudoCaso?.plano_intervencao)}
                {renderFieldWide("14. Articulação com a Sala Regular", dadosEstudoCaso?.articulacao_sala_regular)}
                {renderFieldWide("15. Articulação com a Família e Equipe Multiprofissional", dadosEstudoCaso?.articulacao_familia_equipe)}
                {renderFieldWide("16. Acompanhamento e Reavaliação", dadosEstudoCaso?.acompanhamento_reavaliacao)}
                {renderFieldWide("17. Considerações Finais", dadosEstudoCaso?.consideracoes_finais)}
            </div>
        </Modal>
    );
};

export default ModalEstudoCasoPAEE;
